// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuButton_button__aXzc2","default":"MenuButton_default__XnkOa","circuit":"MenuButton_circuit__4hy8_","icon":"MenuButton_icon__DWd32","text":"MenuButton_text__gFmXE"};